module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "TOCFBM"
  }, [_c('strong', [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "TOCCT"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c01.htm"
    }
  }, [_c('strong', [_vm._v("Cake Decorating")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOCA"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c02.htm"
    }
  }, [_c('strong', [_vm._v("Beautiful Birdie Biscuits")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOCA"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c03.htm"
    }
  }, [_c('strong', [_vm._v("Little Pot Cupcakes")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOCA"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c04.htm"
    }
  }, [_c('strong', [_vm._v("Superstar Cake Pops")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOCA"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c05.htm"
    }
  }, [_c('strong', [_vm._v("Elegant Mini Cakes")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOCA"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c06.htm"
    }
  }, [_c('strong', [_vm._v("Pansy Posy Cupcakes")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOCA"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c07.htm"
    }
  }, [_c('strong', [_vm._v("Christmas Tree Cakes")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOCA"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c08.htm"
    }
  }, [_c('strong', [_vm._v("Pink Daisy Cupcakes")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOCA"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c09.htm"
    }
  }, [_c('strong', [_vm._v("Celebration Mini Cakes")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOCA"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c10.htm"
    }
  }, [_c('strong', [_vm._v("Frilly Flower Cupcakes")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOCA"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c11.htm"
    }
  }, [_c('strong', [_vm._v("Mini Christmas Pudding Cakes")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOCA"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c12.htm"
    }
  }, [_c('strong', [_vm._v("Button Blossom Cupcakes")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOCFBM"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c13.htm"
    }
  }, [_c('strong', [_vm._v("Suppliers")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOCFBM"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c14.htm"
    }
  }, [_c('strong', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOCFBM"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c15.htm"
    }
  }, [_c('strong', [_vm._v("Templates")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOCFBM"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c16.htm"
    }
  }, [_c('strong', [_vm._v("Get more free projects!")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOCFBM"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/cop.htm"
    }
  }, [_c('strong', [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-349bca82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 60
// module chunks = 0